import angular from 'angular';

export default angular.module('shared').constant('entitlementConstants', {
    platform: 'Platform',
    platformUser: 'Platform User',
    platformUsers: 'Platform Users',
    device: 'Device',
    devices: 'Devices',
    globalUsage: 'Global Usage',
    cloudStorage: 'Cloud Storage',
    cloudBandwidth: 'Cloud Bandwidth',
    monthlyCloudBandwidth: 'Monthly Cloud Bandwidth'
});



// WEBPACK FOOTER //
// ./modules/shared/constants/entitlement.constant.js